import React from 'react';
import MessageDialog from 'root/globals/dialogs/MessageDialog';
import Model from 'root/libs/exaforte/react/Model';
import _ from 'root/libs/exaforte/react/lodash';

export default class DeleteDialog extends MessageDialog {
    _handleConfirm() {
        let models = this.props.controller.get_models_from_data({data: {models: (_.isArray(this.props.component) ? this.props.component : [this.props.component]), filter_field: {id: {value: this.props.controller.component.state.selected_ids, type: 'includes_desc'}}}, models: {return_models_split_components: false}});

        for(let i in models)
            models[i].remove();
        
        this.props.controller.save({remove_models_after_save: true}).then(response => {
            if(response.status)
            {
                let removed_amount = _.size(_.filter(response.models[this.props.component], model => model.removed === 't'));
                
                this.props.controller.component.setState({selected_ids: [], amount: this.props.controller.component.state.amount - removed_amount});
                this.props.closeCallback();
            }
        });
    }
}

DeleteDialog.defaultProps = {
    error: true,
};